import { render, staticRenderFns } from "./PageHeaderNav.vue?vue&type=template&id=1b22943e&scoped=true&"
import script from "./PageHeaderNav.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderNav.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeaderNav.vue?vue&type=style&index=0&id=1b22943e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22943e",
  null
  
)

export default component.exports